<div class="dashboard-wrap">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <a href="/home">
      <img src="../../assets/svg/accent_logo_color.svg" alt="sautiDB logo" />
    </a>
    <button
      class="btn m-0 justify-content-center align-items-center log-out-btn"
      (click)="logOut()"
      [ngClass]="currentRoute === '/analytics' ? 'd-none' : 'd-flex'"
    >
      <svg
        width="23"
        height="25"
        viewBox="0 0 23 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="mr-2"
      >
        <path
          d="M22.4199 13.5651C22.4194 15.5984 21.8659 17.5934 20.8186 19.3363C19.7713 21.0792 18.2697 22.5045 16.4745 23.4594C14.6793 24.4144 12.6582 24.863 10.6276 24.7574C8.59696 24.6518 6.63331 23.9958 4.9469 22.8598C3.26049 21.7237 1.91483 20.1503 1.05404 18.3082C0.193241 16.466 -0.150281 14.4244 0.0602567 12.4019C0.270795 10.3795 1.02746 8.45238 2.24924 6.82699C3.47101 5.20161 5.11187 3.93915 6.99612 3.1748C7.10253 3.12642 7.21763 3.10009 7.33449 3.09739C7.45136 3.0947 7.56755 3.11569 7.67608 3.15911C7.78461 3.20252 7.88323 3.26747 7.96599 3.35002C8.04874 3.43257 8.11393 3.53103 8.15761 3.63946C8.20129 3.74788 8.22256 3.86403 8.22015 3.98089C8.21774 4.09776 8.19169 4.21293 8.14357 4.31946C8.09544 4.42599 8.02625 4.52167 7.94016 4.60074C7.85407 4.67981 7.75285 4.74062 7.64262 4.77952C5.60588 5.60693 3.92009 7.11661 2.87387 9.05008C1.82765 10.9836 1.48606 13.2206 1.90758 15.3782C2.32911 17.5358 3.48753 19.4798 5.18453 20.8773C6.88153 22.2749 9.01156 23.039 11.2099 23.039C13.4083 23.039 15.5384 22.2749 17.2354 20.8773C18.9324 19.4798 20.0908 17.5358 20.5123 15.3782C20.9338 13.2206 20.5923 10.9836 19.546 9.05008C18.4998 7.11661 16.814 5.60693 14.7773 4.77952C14.667 4.74062 14.5658 4.67981 14.4797 4.60074C14.3936 4.52167 14.3244 4.42599 14.2763 4.31946C14.2282 4.21293 14.2022 4.09776 14.1997 3.98089C14.1973 3.86403 14.2186 3.74788 14.2623 3.63946C14.306 3.53103 14.3712 3.43257 14.4539 3.35002C14.5367 3.26747 14.6353 3.20252 14.7438 3.15911C14.8523 3.11569 14.9685 3.0947 15.0854 3.09739C15.2023 3.10009 15.3174 3.12642 15.4238 3.1748C17.4967 4.00642 19.2719 5.44159 20.5194 7.29425C21.7669 9.1469 22.429 11.3316 22.4199 13.5651ZM11.2099 12.526C11.4396 12.526 11.6598 12.4348 11.8222 12.2724C11.9846 12.1101 12.0758 11.8898 12.0758 11.6602V0.865856C12.0758 0.636216 11.9846 0.415983 11.8222 0.253603C11.6598 0.0912237 11.4396 0 11.2099 0C10.9803 0 10.7601 0.0912237 10.5977 0.253603C10.4353 0.415983 10.3441 0.636216 10.3441 0.865856V11.6602C10.3441 11.7739 10.3665 11.8865 10.41 11.9915C10.4535 12.0966 10.5173 12.192 10.5977 12.2724C10.6781 12.3528 10.7735 12.4166 10.8786 12.4601C10.9836 12.5036 11.0962 12.526 11.2099 12.526Z"
          fill="#272937"
        />
      </svg>
      <span class="log-out-txt">Sign Out</span>
    </button>
  </div>
  <h1 class="dash-heading text-capitalize font-weight-bold mb-4">overview</h1>
  <div class="chart-wrapper">
    <div class="row mb-3">
      <div class="col-sm-12 col-lg-6 mb-4">
        <div class="record-wrap d-flex align-items-center p-3">
          <img
            src="../../assets/svg/total_rec.svg"
            alt="total record icon"
            class="mr-4"
          />
          <div class="">
            <p class="record-txt text-capitalize mb-2">total recordings</p>
            <h1 class="record-count font-weight-bold">{{totalRecording && totalRecording}}</h1>
          </div>
        </div>
      </div>
      <!-- <div class="col-sm-12 col-lg-4 mb-3">
        <div class="record-wrap d-flex align-items-center p-3">
          <img
            src="../../assets/svg/week_rec.svg"
            alt="week record icon"
            class="mr-4"
          />
          <div class="">
            <p class="record-txt text-capitalize mb-2">
              this week's recordings
            </p>
            <h1 class="record-count font-weight-bold">85</h1>
          </div>
        </div>
      </div> -->
      <div class="col-sm-12 col-lg-6 mb-3">
        <div class="record-wrap d-flex align-items-center p-3">
          <img
            src="../../assets/svg/today_rec.svg"
            alt="today record icon"
            class="mr-4"
          />
          <div class="">
            <p class="record-txt text-capitalize mb-2">today's recordings</p>
            <h1 class="record-count font-weight-bold">{{todayRecording && todayRecording}}</h1>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="d-flex justify-content-end align-items-center mb-5">
      <div class="d-flex align-items-center">
        <div class="d-flex align-items-center mr-5">
          <img
            src="../../assets/svg/filter.svg"
            alt="total record icon"
            class="mr-3"
          />
          <h4 class="text-capitalize font-weight-bold m-0">filter</h4>
        </div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>select native language</mat-label>
          <mat-select
            [(value)]="nativeSelected"
            (selectionChange)="onChangeOtherLang()"
            formControlName="nationality"
          >
            <mat-option
              matSelect
              *ngFor="let item of nativeLanguageOptions"
              [value]="item"
            >
              {{ item }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div> -->

    <!-- Chart -->
    <div class="d-block mb-5 cht-wrap">
      <canvas
        baseChart
        height="120px"
        [datasets]="lineChartData"
        [labels]="lineChartLabels"
        [options]="lineChartOptions"
        [colors]="lineChartColors"
        [legend]="lineChartLegend"
        [chartType]="lineChartType"
        [plugins]="lineChartPlugins"
      >
      </canvas>
    </div>

    <div class="row mb-3">
      <div class="col-sm-12 col-lg-6">
        <div class="cht-wrap p-4 mb-3">
          <h5 class="font-weight-bold">Age of Speaking English</h5>
          <canvas
            baseChart
            [data]="doughnutChartData"
            [labels]="doughnutChartLabels"
            [chartType]="doughnutChartType"
            [colors]="donutColors"
            [options]="options"
          >
          </canvas>
        </div>
      </div>

      <div class="col-sm-12 col-lg-6">
        <div class="cht-wrap p-4 mb-3">
          <h5 class="font-weight-bold">Fluent Language</h5>
          <!-- <canvas
            baseChart
            [datasets]="barChartData"
            [labels]="barChartLabels"
            [options]="barChartOptions"
            [plugins]="barChartPlugins"
            [legend]="barChartLegend"
            [chartType]="barChartType"
            [colors]="barchartColors"
          >
          </canvas> -->
          <canvas
            baseChart
            [data]="pieChartData"
            [labels]="pieChartLabels"
            [chartType]="pieChartType"
            [options]="pieChartOptions"
            [plugins]="pieChartPlugins"
            [legend]="pieChartLegend"
            [colors]="pieChartColors"
            [options]="options"
          >
          </canvas>
        </div>
      </div>
    </div>
  </div>
</div>
